


























import { Component, Prop, Model } from 'vue-property-decorator';
import _ from 'lodash';

import Vue from 'vue';

@Component
export default class UiTextarea extends Vue {
  @Prop()
  value: any;

  @Prop({ default: '' })
  label: string;

  @Prop()
  labelHelp: string;

  @Prop({ default: 0 })
  hideDetails: number;

  @Prop({ default: false })
  readonly : boolean;

  @Prop({ default: false })
  disabled : boolean;

  @Prop({ default: 5 })
  rows: number;

  @Prop({ default: '' })
  placeholder: string;

  @Prop({ default: [] })
  errorMessages: [];

  get errorMsg() {
    if (this.errorMessages.length && Array.isArray(this.errorMessages)) {
      return this.errorMessages.join('<br>');
    }

    return this.errorMessages
  }

  get hasError() {
    return !_.isEmpty(this.errorMessages)
  }

}
